module.exports = __webpack_public_path__ + "img/ieee-cis-singapore.766e69d9.png";